import React, { useEffect, useState } from "react";
import { Button, Icon, Text, toast } from "@telia/teddy";
import { useDispatch, useSelector } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { PhoneNumberFormatters } from "../../../../app/utils";
import { FieldSet, Input } from "../../../../forms";
import { isTypeLoading } from "../../../../loading/state/selectors";
import { RapidForm } from "../../../../rapidform";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { setCustomerContactInfo } from "../../../state/actions";
import { RETAILER_SET_CONTACT_INFO } from "../../../state/actionTypes";
import { getFormById } from "../../../state/selectors/formSelectors";
import { getCustomerExistingAccounts, getIsPrepaid } from "../../../state/selectors/customerSelectors";
import TEXT from "../../../text-consts";
import "./CustomerContactInfo.less";
import { CustomerSection } from "../CustomerSection";

const CustomerContactInfo = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState<string | null>(null);
    const isSettingContactInfo = useSelector((state: RootState) => isTypeLoading(state, RETAILER_SET_CONTACT_INFO));
    const form = useSelector((state: RootState) => getFormById(state, FORM_ID.CUSTOMER_CONTACT_INFO));
    const existingAccounts = useSelector((state: RootState) => getCustomerExistingAccounts(state));
    const isExistingCustomer = existingAccounts.length > 0;
    const isPrepaid = useSelector((state: RootState) => getIsPrepaid(state));
    const phone = form.values.details?.[VALIDATION_FIELD.CONTACT_PHONE_NON_REQUIRED];
    const hasContactValues = !!form.values.details?.email;
    const [edit, setEdit] = useState(!hasContactValues && !isExistingCustomer);
    const emailInputRef = React.useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!hasContactValues && !isExistingCustomer) {
            setEdit(true);
        }
    }, [hasContactValues, isExistingCustomer]);

    useEffect(() => {
        if (edit) {
            emailInputRef.current?.focus();
        }
    }, [edit]);

    const handleSubmit = async () => {
        try {
            await dispatch(setCustomerContactInfo());
            toast.success(`Kontaktinfo lagret`, {
                position: "top-center",
            });
            setEdit(false);
            setTimeout(() => {
                const nextButton = document.getElementById("neste-abonnement-btn");
                nextButton?.focus();
            }, 0);
        } catch (e) {
            setError(TEXT.ERRORS.CUSTOMER_CONTACT_INFO_ERROR);
        }
    };

    return (
        <CustomerSection className="customer-contact-info" heading="Kontaktinfo" error={error}>
            {!edit && (
                <div className="customer-contact-info__section">
                    <div>
                        <Text className="customer-contact-info__details" data-di-mask>
                            {" "}
                            {form.values.details.email}
                        </Text>
                        {!isPrepaid && !!phone && (
                            <Text className="customer-contact-info__details" data-di-mask>
                                {PhoneNumberFormatters[0].displayFn(phone)}
                            </Text>
                        )}
                    </div>
                    {(hasContactValues || isExistingCustomer) && (
                        <Button
                            className="reseller-contact-card__creditCheck-btn"
                            variant="text"
                            type="button"
                            onClick={() => {
                                setEdit(true);
                            }}
                        >
                            Endre
                            <Icon
                                className="reseller-contact-card__creditCheck-icon"
                                name="edit"
                                aria-hidden="true"
                                focusable="false"
                            />
                        </Button>
                    )}
                </div>
            )}

            {edit && (
                <RapidForm
                    id={FORM_ID.CUSTOMER_CONTACT_INFO}
                    action={"#"}
                    values={form?.values || {}}
                    visible={form?.visible || {}}
                    started={form?.started || {}}
                    errors={form?.errors || {}}
                    onSubmit={handleSubmit}
                >
                    <FieldSet name="details">
                        <div className="customer-contact-info__name">
                            <Input
                                className="customer-contact-info__name-input"
                                type="email"
                                name="email"
                                label="E-post"
                                disabled={false}
                                data-di-mask
                                inputRef={emailInputRef}
                            />
                            {!isPrepaid && (
                                <Input
                                    className="customer-contact-info__name-input"
                                    type="tel"
                                    name={VALIDATION_FIELD.CONTACT_PHONE_NON_REQUIRED}
                                    label="Kontaktnummer"
                                    disabled={false}
                                    data-di-mask
                                />
                            )}
                        </div>
                    </FieldSet>
                    <div className="customer-contact-info__action">
                        <Button
                            mt="300"
                            type="submit"
                            loading={isSettingContactInfo}
                            form={FORM_ID.CUSTOMER_CONTACT_INFO}
                            variant="primary"
                        >
                            Lagre
                        </Button>
                    </div>
                </RapidForm>
            )}
        </CustomerSection>
    );
};

export default CustomerContactInfo;
